import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.farumkloak.dk";
const DEFAULT_OG =
  "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_eda5de61-7412-4813-8c24-01117e9f4a36/artifacts/v52fsjd9_gruppe%20billede.jpg&w=1200&h=630&fit=cover&output=jpg&q=85";
const NOINDEX_PRELAUNCH = process.env.REACT_APP_PRELAUNCH === "true";

export const SEO = ({
  title,
  description,
  image,
  noindex = false,
  type = "website",
  jsonLd,
}) => {
  const location = useLocation();
  const canonical = `${SITE_URL}${location.pathname === "/" ? "/" : location.pathname.replace(/\/$/, "")}`;
  const ogImage = image || DEFAULT_OG;
  const fullTitle = title
    ? `${title} | Farum Kloak`
    : "Farum Kloak — Autoriseret kloakmester & rottebekæmpelse";
  const desc =
    description ||
    "Autoriseret kloakmester og certificeret rottebekæmper i Nordsjælland. Døgnvagt, kloakservice, no-dig, TV-inspektion og rottebekæmpelse.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {(noindex || NOINDEX_PRELAUNCH) && (
        <meta name="robots" content="noindex, nofollow" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Farum Kloak" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="da_DK" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "Plumber",
  name: "Farum Kloak ApS",
  image: DEFAULT_OG,
  "@id": `${SITE_URL}/#organization`,
  url: `${SITE_URL}/`,
  telephone: "+4544480616",
  priceRange: "$$",
  areaServed: [
    { "@type": "City", name: "Farum" },
    { "@type": "City", name: "Værløse" },
    { "@type": "AdministrativeArea", name: "Nordsjælland" },
    { "@type": "AdministrativeArea", name: "Storkøbenhavn" },
  ],
  address: {
    "@type": "PostalAddress",
    addressCountry: "DK",
    addressRegion: "Hovedstaden",
    addressLocality: "Farum",
  },
  sameAs: [],
};

export { SITE_URL };
